module.exports = __webpack_public_path__ + "3094988f9a64f362cc49f4129e469a58.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/umbrella-purple.png
// module id = 2337
// module chunks = 0